import React from 'react';
import PropTypes from 'prop-types';

import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import MUSubjectIcon from '@mui/icons-material/Subject';

const SubjectIcon = (props) => {
  const { subject, open } = props;

  if (subject.subjects?.length > 0) {
    return open ? <FolderOpenIcon /> : <FolderIcon />;
  }
  return <MUSubjectIcon />;
};

SubjectIcon.propTypes = {
  subject: PropTypes.object.isRequired,

  open: PropTypes.bool,
};

SubjectIcon.defaultProps = {
  open: false,
};

export default SubjectIcon;
